<template>
  <div>
    <input 
      type="email"
      v-model="email"
      :placeholder="$t('login.emailPlaceholder')"
      @focus="emailError = false"
      :class="{error: emailError}"
      @keypress.enter="resetPassword">
      <div class="button-wrap">
        <div class="button-round" @click="resetPassword">{{$t('login.resetPassword')}} &nbsp;<span class="material-icons">arrow_right_alt</span></div>
      </div>
  </div>
</template>

<script>
import api from  '@/api';
export default {
  data() {
    return {
      emailError: false,
      email: ''
    }
  },
  methods: {
    async resetPassword () {
      let params = {
        email: this.email
      }
      this.startLoading();
        try {
          const res = await api.getResetPasswordEmail(params);
          if (res.data.result === 'ok') {
            let msg = {
              message: this.$t('login.sucessfulPasswordRestore')
            }
            this.EventBus.$emit('info', msg);
            this.$router.push('/login/');
          }
        } catch (error) {
          this.handleError(error);
        }
      this.stopLoading();
    }
  }
}
</script>

<style scoped lang='scss'>
input {
    transition: border-color .2s ease;
    &.error {
        border-color: red;
    }
}
.button-wrap {
    margin: 30px 0 0 0;
    display: flex;
    justify-content: flex-end;
}
.button-round {
    background: var(--button-color-yellow);
}
</style>